export const loginI18nFallbacks = {
  WELCOME_BACK: 'Welcome back',
  SIGN_IN_TO_ACCOUNT: 'Sign in to your account.',
  EMAIL_ADDRESS: 'Email address',
  REMEMBER_ME: 'Remember me',
  SIGN_IN: 'Sign In',
  LOGIN_CAMPAIGN_HEADLINE: 'Campaigns',
  LOGIN_CAMPAIGN_HEADLINE_ACCENT: 'made simple.',
  LOGIN_CAMPAIGN_TAGLINE: 'Results Made Measurable.',
  LOGIN_FEATURE_CONTACTS_TITLE: 'Manage contacts easily',
  LOGIN_FEATURE_CONTACTS_DESC: 'Organize and segment your audience in just a few clicks.',
  LOGIN_FEATURE_AUDIENCE_TITLE: 'Build audiences without technical knowledge',
  LOGIN_FEATURE_AUDIENCE_DESC: 'Smart tools to help you create the right audience every time.',
  LOGIN_FEATURE_CAMPAIGNS_TITLE: 'Send, schedule and track campaigns',
  LOGIN_FEATURE_CAMPAIGNS_DESC: 'Deliver the right message and measure real results.',
  CONTINUE_WITH_PROVIDER: 'Continue with {{provider}}',
  OR_CONTINUE_WITH: 'or',
  DONT_HAVE_ACCOUNT: "Don't have an account?",
  SIGN_UP: 'Sign up',
  ENTER_YOUR_EMAIL: 'Enter your email',
  ENTER_YOUR_PASSWORD: 'Enter your password',
  PASSWORD: 'Password',
  EMAIL_ADDRESS_REQUIRED: 'Email address is required',
  PASSWORD_REQUIRED: 'Password is required',
  FORGOT_PASSWORD: 'Forgot Password?',
} as const;
